import React from "react";
import { Dialog } from "@headlessui/react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getLeads } from "../../../redux/actions/userSubscription";
import { IKImage } from "imagekitio-react";
import { useState } from "react";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { getBookingProduct } from "../../../redux/actions/pricing";
import { SET_IS_ELIGIBLE_FOR_LEARNTUBE_MAX } from "../../../redux/actions/types";
import "./index.css";
const EligibleModal = ({
  isModalEnabled,
  setIsModalEnabled,
  razorpayHandler,
  cardData,
}) => {
  const user_name = useSelector((store) => store?.profileDetails?.name);
  const [pricingSpinner1, setPricingSpinner1] = useState(false);
  const [pricingSpinner2, setPricingSpinner2] = useState(false);
  const user_plan = useSelector((store) => store?.userSubscription?.role_type);
  const user_id = useSelector((store) => store?.profileDetails?.id);
  const discountData = useSelector((store) => store?.userDiscount?.discount);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [bookingProduct, setBookingProduct] = useState({ cost: 0 });

  function getRandomArbitary() {
    const d = new Date();
    let day = d.getDay();

    if (day === 0) return 1;
    else return 8 - day;
  }

  useEffect(() => {
    dispatch(
      getBookingProduct((successObj) => {
        setBookingProduct(successObj);
      }),
    );
    dispatch({ type: SET_IS_ELIGIBLE_FOR_LEARNTUBE_MAX, payload: true });
  }, []);
  return (
    <Dialog
      open={isModalEnabled}
      onClose={() => {
        setIsModalEnabled(!isModalEnabled);
      }}
      as="div"
      className="fixed inset-0 z-10 flex flex-col  items-center justify-center overflow-y-auto"
    >
      <Dialog.Overlay className="fixed inset-0 z-10 bg-black opacity-70" />
      <Dialog.Title />
      <Dialog.Description />
      <div className="z-10 flex w-11/12 flex-col items-center justify-center rounded-2xl bg-white px-4 py-3 shadow-2xl md:w-2/5  lg:w-[375px]">
        <img
          urlEndpoint="https://img.learntube.ai/public-assets/"
          src={
            "https://img.learntube.ai/public-assets/PRICING/imagenew.svg?updatedAt=1662738813436"
          }
          transformation={[
            {
              height: "100",
              width: "100",
            },
          ]}
          className="h-[157px] w-[190px] self-start "
        />
        <div className="flex flex-row items-center justify-center self-start">
          <img
            urlEndpoint="https://img.learntube.ai/public-assets/"
            src={
              "https://img.learntube.ai/public-assets/PRICING/img10.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1658938810160"
            }
            transformation={[
              {
                height: "160",
                width: "160",
              },
            ]}
            className=" mr-1 h-5"
          />
          <div className="text-2xl font-bold ">
            {user_name?.split(" ")?.[0]}, You Are Eligible
          </div>
        </div>
        <div className="mt-2 text-sm">
          Congratulations, we have reviewed your profile & believe with{" "}
          {cardData?.product_name} you will have a&nbsp;
          <small className="text-sm font-bold text-[#2BBD13]">91%+</small>
          &nbsp;chance of getting hired.
        </div>
        <div className=" text-sm">
          Our experts will work with you & provide 100% placement support!
        </div>
        <div className="mt-4 self-start text-sm"> Secure your seat now!</div>
        <div className="self-start text-sm ">
          Seats Left:{" "}
          <span className="font-bold text-red-600">{getRandomArbitary()}</span>
        </div>
        <div className="mt-5 w-full">
          <button
            className="modalbutton-background flex w-full flex-col items-center justify-center rounded-3xl px-2 py-2 text-white"
            onClick={(e) => {
              if (user_id) {
                setPricingSpinner1(true);
                dispatch(
                  getLeads({
                    user_id,
                    user_plan,
                    product_id: cardData?.products_id,
                    product_name: cardData?.product_name,
                    product_type: "subscription",
                    is_visit: false,
                  }),
                );
                razorpayHandler(cardData?.products_id, () => {
                  setPricingSpinner1(false);
                  setIsModalEnabled(false);
                });
              } else {
                navigate("/login", { state: { from: location } });
              }
            }}
          >
            {pricingSpinner1 === true ? (
              <div className="h-8 w-8 animate-spin rounded-full border-4 border-white border-t-transparent"></div>
            ) : (
              <>
                <div className="text-[16px]">Upgrade Now</div>
                <div className=" text-[12px] text-white ">
                  &#x20B9; {cardData?.cost_details?.final_cost_total} For{" "}
                  {cardData?.product_tab_heading}
                </div>
              </>
            )}
          </button>

          <button
            className="mt-1 flex w-full flex-col items-center justify-center rounded-3xl border-2 border-pricing_blue px-2 py-2 font-medium text-pricing_blue md:mt-2"
            onClick={(e) => {
              if (user_id) {
                setPricingSpinner2(true);
                dispatch(
                  getLeads({
                    user_id,
                    user_plan,
                    product_id: 18,
                    product_name: "LearnTube Max",
                    product_type: "subscription",
                    is_visit: false,
                  }),
                );
                razorpayHandler(18, () => {
                  setPricingSpinner2(false);
                  setIsModalEnabled(false);
                });
              } else {
                navigate("/login", { state: { from: location } });
              }
            }}
          >
            {pricingSpinner2 === true ? (
              <div
                className="spinner-border
            inline-block
            h-7
            w-7
            animate-spin
            rounded-full border-2 
            border-t-0
            border-pricing_blue
            bg-clip-text
            "
              ></div>
            ) : (
              <>
                <div>Reserve Seat for &#x20B9; {bookingProduct?.cost}</div>
                <div className="mt-1 text-xs font-medium text-black">
                  *Pay Balance &#x20B9;{" "}
                  {cardData?.cost_details?.final_cost_total -
                    bookingProduct?.cost +
                    100}{" "}
                  within 30 days
                </div>
              </>
            )}
          </button>
        </div>
      </div>
    </Dialog>
  );
};

export default EligibleModal;
